import cn from "classnames";
import type { ReactNode } from "react";

import { getRichTextAlignmentClassName } from "./richTextAlignment.config";

export function RichTextAlignMark({
  alignment,
  children,
}: RichTextAlignMarkProps) {
  return (
    <span
      className={cn("block w-full", getRichTextAlignmentClassName(alignment))}>
      {children}
    </span>
  );
}

type RichTextAlignMarkProps = {
  alignment: "left" | "center" | "right";
  children: ReactNode;
};
